import { NavLink } from 'react-router-dom';
import { UploadIcon } from 'components/iconComponent/UploadIcon';
import s from './UploadButton.module.css';

const UploadButton = () => {
  return (
    <NavLink to="/upload">
      <button className={s.button}>
        <div className={s.button__content}>
          <div className={s.icon}>
            <UploadIcon />
          </div>
          <span className={s.button__name}>upload</span>
        </div>
      </button>
    </NavLink>
  );
};

export { UploadButton };
